"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WebSocket = require("isomorphic-ws");
class DMSNode extends WebSocket {
    constructor(address, options) {
        super(address, options);
    }
}
exports.default = DMSNode;
//# sourceMappingURL=DMSNode.js.map